module.exports = __webpack_public_path__ + "static/media/flag-da.2e7fdb32.webp";